import { render, staticRenderFns } from "./addActivity.vue?vue&type=template&id=66078b8b&scoped=true"
import script from "./addActivity.vue?vue&type=script&lang=js"
export * from "./addActivity.vue?vue&type=script&lang=js"
import style0 from "./addActivity.vue?vue&type=style&index=0&id=66078b8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66078b8b",
  null
  
)

export default component.exports